"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.EditorialXlCardsDefaultProps = exports.EditorialXlCards = void 0;
var _editorialXlCards = _interopRequireDefault(require("./components/editorial-xl-cards"));
exports.EditorialXlCards = _editorialXlCards["default"];
var _editorialXlCards2 = _interopRequireDefault(require("./components/editorial-xl-cards.props/editorial-xl-cards.defaultProps"));
exports.EditorialXlCardsDefaultProps = _editorialXlCards2["default"];